
export enum SharedSettingsEntityType {
    SitePage = 'sitePage'
}
